import React from "react";
import "./Popular_Vendors.css";
import Common_Vendor_Card from "../../../common_components/common-vendor-card/Common_Vendor_Card";
import Common_Headings from "../../../common_components/common_heading/Common_Headings";

const vendors = [
  {
    id: 1,
    name: "Jay Hardware",
    location: "Katraj, Pune Maharashtra",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 2,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune Maharashtra",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 3,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune Maharashtra",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
];

function Popular_Vendors() {
  return (
    <div className="container mt-4 vendor-section">
      <Common_Headings title="POPULAR VENDOR" />

      <div className="row">
        {vendors.map((vendor) => (
          <div
            key={vendor.id}
            className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
          >
            <Common_Vendor_Card vendor={vendor} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Popular_Vendors;
